import React from 'react';
import { DefaultIconProps } from '@gamiphy/icons/types';

const Profile: React.FC<DefaultIconProps> = ({
  color,
}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1538_2315)">
      <path opacity="0.4" d="M12.1608 10.8694C12.051 10.8594 11.9406 10.8594 11.8308 10.8694C10.667 10.8261 9.56664 10.3279 8.7664 9.48178C7.96615 8.63568 7.52993 7.5093 7.55155 6.34491C7.57317 5.18051 8.0509 4.07111 8.882 3.25529C9.7131 2.43948 10.8312 1.98242 11.9958 1.98242C13.1604 1.98242 14.2785 2.43948 15.1096 3.25529C15.9407 4.07111 16.4184 5.18051 16.44 6.34491C16.4616 7.5093 16.0254 8.63568 15.2252 9.48178C14.4249 10.3279 13.3246 10.8261 12.1608 10.8694Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.1607 14.5619C4.7407 16.1819 4.7407 18.8219 7.1607 20.4319C8.67397 21.3351 10.4034 21.812 12.1657 21.812C13.928 21.812 15.6574 21.3351 17.1707 20.4319C19.5907 18.8119 19.5907 16.1719 17.1707 14.5619C15.6558 13.6635 13.927 13.1895 12.1657 13.1895C10.4044 13.1895 8.67562 13.6635 7.1607 14.5619V14.5619Z" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1538_2315">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>

);

export default Profile;
